import React from "react";
import Checkbox from "_c/Checkbox";
import PT from "prop-types";
import * as S from "./styled";
import { useSelector } from "react-redux";
import { Selectors } from "@/store/locale/selectors";

const ns = "common:common_agreement";
const CommonAgreement = (props) => {
  const locale = useSelector(Selectors.getLocale);
  return (
    <div
      css={`
        margin-top: 15px;
        text-align: center;
      `}
      className={props.className}
    >
      <Checkbox
        defaultChecked={props.defaultChecked}
        onChange={(e) => props.onChange(e.target.checked)}
        id="common-agreement-check"
        css={`
          > span {
            margin-right: 0;
          }
        `}
      />
      <S.Attention>
        <span>{props.t(`${ns}.1`)}</span>
        <S.Politics
          target="_blank"
          rel="noopener noreferrer"
          //href={`/pdf/privacy-policy-${locale}.pdf`}
          href={`/privacy-policy`}
        >
          {props.t(`${ns}.2`)}
        </S.Politics>{" "}
        <span>{props.t(`${ns}.3`)}</span>{" "}
        <S.Politics
          target="_blank"
          rel="noopener noreferrer"
          href={`/pdf/user-agreement-${locale}.pdf`}
        >
          {props.t(`${ns}.4`)}
        </S.Politics>
      </S.Attention>
    </div>
  );
};
CommonAgreement.propTypes = {
  defaultChecked: PT.bool,

  t: PT.func.isRequired,
  onChange: PT.func.isRequired,
};
export default CommonAgreement;
